import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { shutdown } from '@intercom/messenger-js-sdk';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { UserType } from 'src/app/models/enums/user-type.enum';
import { RedirectionUrls } from 'src/app/shared/global/redirectionsUrls';
import { UserService } from 'src/app/core/services/user/user.service';
import { SentryService } from 'src/app/core/services/sentry/sentry.service';
/**
  declare login component
 *  
*/
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  loginFormGroup: UntypedFormGroup;
  emailControl: UntypedFormControl;
  userNameControl: UntypedFormControl;
  passwordControl: UntypedFormControl;
  errorAuth: boolean = false;
  isLoggedIn = false;
  returnUrl: any;
  user = UserType;
  redirectionUrls = RedirectionUrls.redirectRoot;
  errMessage: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private titleService: Title,
    private userService: UserService,
    private sentryService: SentryService,
  ) { }

  ngAfterViewInit() {
    document.querySelector('body').classList.add('login');
  }

  ngOnDestroy() {
    document.querySelector('body').classList.remove('login');
  }

  ngOnInit(): void {
    this.createForm();
    this.createFormControls();
    this.titleService.setTitle('تسجيل الدخول | عاين');
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
  }

  createFormControls() {
    return this.loginFormGroup.controls;
  }

  createForm() {
    this.loginFormGroup = this.formBuilder.group({
      email: [null, Validators.required],
      password: [null, Validators.required],
      remember_me: [false],
    });
  }

  remeberMe(remeber) {
    this.isLoggedIn = remeber.checked;
  }

  save(): void {
    this.userService.clearAll();
    this.authenticationService.authLogin(this.loginFormGroup.value).subscribe(
      (data) => {
        this.errorAuth = false;

        // Check if user_type is null or if user type is not allowed
        if (!data.user.profile.user_type || [this.user.Client, this.user.Inspector].includes(data.user.profile.user_type)) {
          this.errorAuth = true;
          this.errMessage = data.user.profile.user_type == null ? 'خطأ في نوع المستخدم. يرجى التواصل مع الإدارة' : 'خطأ في البريد الإلكتروني أو كلمة المرور أو نوع المستخدم';
        } else {
          shutdown()
          this.authenticationService.setLoggedInUser(data.user);
          this.userService.setCurrentUser(data);
          this.sentryService.setCurrentUser(data.user);
          if (this.returnUrl) {
            this.router.navigateByUrl(this.returnUrl);
          } else {
            this.router.navigateByUrl(this.redirectionUrls[data.user.profile.user_type].url);
          }
          this.titleService.setTitle('الرئيسية | عاين');
        }
      },
      () => {
        try {
          this.errorAuth = true;
        } catch (err) { }
      }
    );
  }
  closeError() {
    this.errorAuth = false;
  }
}
